import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import UserProfileView from '@/views/UserProfileView.vue'
import EventHomeView from '@/views/EventHomeView.vue'
import EventInfoView from '@/views/EventInfoView.vue'
import TalklistView from '@/views/TalklistView.vue'
import TalkDetailView from '@/views/TalkDetailView.vue'
import SpeakerListView from '@/views/SpeakerListView.vue'
import SpeakerDetailView from '@/views/SpeakerDetailView.vue'
import ProductIndexView from '@/views/ProductIndexView.vue'
import SponsorListView from '@/views/SponsorListView.vue'
import ExhibitorListView from '@/views/ExhibitorListView.vue'
import ExhibitorDetailView from '@/views/ExhibitorDetailView.vue'
import FavoriteListView from '@/views/FavoriteListView.vue'
import CommunityListView from '@/views/CommunityListView.vue'
import ContactListView from '@/views/ContactListView.vue'
import ContactDetailView from '@/views/ContactDetailView.vue'
import ChannelView from '@/views/ChannelView.vue'
import ContactChannelView from '@/views/ContactChannelView.vue'
import UserTimelineView from '@/views/UserTimelineView.vue'
import ExhibitorScanView from '@/views/ExhibitorScanView.vue'
import MeetingListView from '@/views/MeetingListView.vue'
import TicketListView from '@/views/TicketListView.vue'
import AIChatView from '@/views/AIChatView.vue'
import IframeView from '@/views/IframeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/accounts/login',
    redirect: () => {
      return '/login'
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: UserProfileView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/contacts',
    name: 'ContactListView',
    component: ContactListView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/timeline',
    name: 'UserTimelineView',
    component: UserTimelineView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/meetings',
    name: 'MeetingListView',
    component: MeetingListView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/tickets',
    name: 'TicketListView',
    component: TicketListView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/exhibitor-scan',
    name: 'ExhibitorScanView',
    component: ExhibitorScanView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile/:favorite-favorites',
    name: 'FavoriteListView',
    component: FavoriteListView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/community',
    name: 'CommunityListView',
    component: CommunityListView,
    props: true,
  },
  {
    path: '/community/:contactId',
    name: 'Contact',
    component: ContactDetailView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/community/:contactId/:channelId',
    name: 'ContactChannelView',
    component: ContactChannelView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/channel-:channelName',
    name: 'Chat',
    component: ChannelView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/talks',
    name: 'Talks',
    component: TalklistView
  },
  {
    path: '/talks/:talkId',
    name: 'Talk Detail',
    component: TalkDetailView
  },
  {
    path: '/:shortName/talks',
    name: 'Event Talks',
    component: TalklistView
  },
  {
    path: '/:shortName/talks/:talkId',
    name: 'Event Talk Detail',
    component: TalkDetailView
  },

  {
    path: '/speakers',
    name: 'Speakers',
    component: SpeakerListView
  },
  {
    path: '/:shortName/speakers',
    name: 'Event Speakers',
    component: SpeakerListView
  },
  {
    path: '/speakers/:speakerId-:speakerName',
    name: 'Speaker Detail',
    component: SpeakerDetailView
  },
  {
    path: '/:shortName/speakers/:speakerId-:speakerName',
    name: 'Event Speaker Detail',
    component: SpeakerDetailView
  },

  {
    path: '/exhibitors',
    name: 'Exhibitors',
    component: ExhibitorListView
  },
  {
    path: '/:shortName/exhibitors',
    name: 'Event Exhibitors',
    component: ExhibitorListView
  },
  {
    path: '/exhibitors/:exhibitorId-:exhibitorName',
    name: 'Exhibitor Detail',
    component: ExhibitorDetailView
  },
  {
    path: '/:shortName/exhibitors/:exhibitorId-:exhibitorName',
    name: 'Event Exhibitor Detail',
    component: ExhibitorDetailView
  },

  {
    path: '/sponsors',
    name: 'Sponsors',
    component: SponsorListView
  },
  {
    path: '/:shortName/sponsors',
    name: 'Event Sponsors',
    component: SponsorListView
  },

  {
    path: '/product-index',
    name: 'ProductIndex',
    component: ProductIndexView
  },
  {
    path: '/:shortName/product-index',
    name: 'Event ProductIndex',
    component: ProductIndexView
  },

  {
    path: '/ai-chat',
    name: 'AiChat',
    component: AIChatView
  },
  // Redirect Django URL patterns for known types to native SPA routes.
  // URL structure from get_absolute_url():
  //   speakers:  {event_url}{speakers_url}speakers/{id}-{slug}/   (speakers_url = 'speaker/')
  //   sessions:  {event_url}{sessions_url}talks/{id}              (sessions_url = 'programm/')
  //   exhibitors:{event_url}{ex_url}exhibitors/{id}-{slug}        (ex_url = 'aussteller/')
  // DE + EN variants: programm/program, aussteller/exhibitors
  {
    path: '/:lang(de|en)/:eventSlug/programm/talks/:talkId',
    redirect: to => '/talks/' + to.params.talkId
  },
  {
    path: '/:lang(de|en)/:eventSlug/program/talks/:talkId',
    redirect: to => '/talks/' + to.params.talkId
  },
  {
    path: '/:lang(de|en)/:eventSlug/speaker/speakers/:rest*',
    redirect: to => '/speakers/' + to.params.rest
  },
  {
    path: '/:lang(de|en)/:eventSlug/aussteller/exhibitors/:rest*',
    redirect: to => '/exhibitors/' + to.params.rest
  },
  {
    path: '/:lang(de|en)/:eventSlug/exhibitors/exhibitors/:rest*',
    redirect: to => '/exhibitors/' + to.params.rest
  },
  // All other /:lang/ paths -> IframeView (bare Django page embedded in SPA)
  {
    path: '/:lang(de|en)/*',
    component: IframeView
  },
  {
    path: '/:shortName/:infopage',
    name: 'EventInfo',
    component: EventInfoView
  },
  {
    path: '/:shortName',
    name: 'EventHome',
    component: EventHomeView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

function getToken() {
  return localStorage.getItem('speaker_tool_token')
}

router.beforeEach((to, from, next) => {
  const token = getToken();

  router.lastRoute = from // memory the last Route

  // Persist current event shortName for bottom nav
  if (to.params.shortName) {
    localStorage.setItem('currentEventShortName', to.params.shortName)
  }

  // If the route requires authentication and token doesn't exist
  if (to.meta.requiresAuth && !token) {
    next('/login?next=' + to.fullPath) // Redirect to login route
  } else {
    next()
  }
})

router.afterEach(() => {
  // Check for app updates on every route change (throttled in storage)
  if (router.app && router.app.$storage) {
    router.app.$storage.checkAppVersion()
  }
})
